import React from 'react';
import styled from 'styled-components';
import StoryContainer from '../../../paragraph-types/Story/styled/StoryContainer';

export default styled.div`
  ${StoryContainer} {
    padding-top: 0;
  }
`;
